import { AxiosResponse } from "axios";

import API from "../api";

const ROUTE_NAME = "notification/push/notification";

export interface UpdatePushNotificationTokenPayload {
  token: string;
  app: string;
  userId: number;
}

const NotificationService = {
  async updatePushNotificationToken(payload: UpdatePushNotificationTokenPayload): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/token`, payload);
  },
  async deletePushNotificationToken(): Promise<AxiosResponse<boolean>> {
    return await API.delete(`/${ROUTE_NAME}/token`);
  },
};

export default NotificationService;

